import { Image } from 'foundations-components/transitional/components/Image';

// @ts-expect-error svg import
import MarketingHubSvg from 'bender-url!./images/MarketingHub.svg';
// @ts-expect-error svg import
import MarketingHubStarterSvg from 'bender-url!./images/MarketingHub_Starter.svg';
// @ts-expect-error svg import
import MarketingHubProSvg from 'bender-url!./images/MarketingHub_Pro.svg';
// @ts-expect-error svg import
import MarketingHubEntSvg from 'bender-url!./images/MarketingHub_Ent.svg';
import { MERCH_CARD_PRODUCT_ICON_STYLE_PROPS, PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS } from './styleProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const MarketingHubProductIcon = ({
  useCase = 'productPageTitle'
}) => {
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: MarketingHubSvg
  }, useCase === 'productPageTitle' ? PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS : MERCH_CARD_PRODUCT_ICON_STYLE_PROPS));
};
export const MarketingHubStarterProductIcon = ({
  useCase = 'merchCard'
}) => {
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: MarketingHubStarterSvg
  }, useCase === 'productPageTitle' ? PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS : MERCH_CARD_PRODUCT_ICON_STYLE_PROPS));
};
export const MarketingHubProfessionalProductIcon = ({
  useCase = 'merchCard'
}) => {
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: MarketingHubProSvg
  }, useCase === 'productPageTitle' ? PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS : MERCH_CARD_PRODUCT_ICON_STYLE_PROPS));
};
export const MarketingHubEnterpriseProductIcon = ({
  useCase = 'merchCard'
}) => {
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: MarketingHubEntSvg
  }, useCase === 'productPageTitle' ? PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS : MERCH_CARD_PRODUCT_ICON_STYLE_PROPS));
};